import styled from "@emotion/styled"

export const StyledEventWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px 22px 24px;
  border-radius: 24px;
  height: 100%;
  overflow: auto;
  background: var(--cms-surface-primary);

  .heading-copy {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .page-title {
    margin: 0;
    font-size: 30px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .page-subtitle {
    margin: 0;
    color: var(--cms-text-secondary);
    font-size: 13px;
    font-weight: 500;
  }

  .event-surface {
    border: 1px solid var(--cms-border);
    border-radius: 18px;
    background: var(--cms-surface-secondary);
    box-shadow: var(--cms-shadow);
    padding: 14px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .filter-shell {
    border: 1px solid var(--cms-border);
    border-radius: 14px;
    background: var(--cms-surface-muted);
    box-shadow: 0 10px 22px rgba(15, 23, 42, 0.06);
    padding: 14px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .filter-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 10px;
    align-items: stretch;
  }

  .filter-grid .search-field {
    grid-column: span 2;
    min-width: 220px;
  }

  .filter-grid .MuiFormControl-root,
  .filter-grid .MuiTextField-root {
    width: 100%;
  }

  .filter-switch {
    min-height: 40px;
    margin: 0;
    padding: 0 10px;
    border: 1px solid var(--cms-border);
    border-radius: 10px;
    background: var(--cms-input-bg);
    color: var(--cms-text-primary);
    font-size: 13px;
    font-weight: 600;
  }

  .filter-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }

  .result-meta {
    font-size: 13px;
    color: var(--cms-text-secondary);
    font-weight: 600;
  }

  .filter-action-right {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  .clear-btn,
  .create-btn {
    text-transform: none;
    font-weight: 700;
    border-radius: 10px;
    min-height: 40px;
    padding: 8px 14px;
  }

  .create-btn {
    box-shadow: 0 12px 24px rgba(37, 99, 235, 0.24);
  }

  .table-shell {
    border: 1px solid var(--cms-border);
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);
    background: var(--cms-surface-secondary);
  }

  .MuiTableCell-head {
    background: var(--cms-table-head-bg);
    color: var(--cms-text-primary);
    font-weight: 700;
    font-size: 12px;
    border-bottom: 1px solid var(--cms-border);
    white-space: nowrap;
  }

  .MuiTableCell-body {
    font-size: 13px;
    color: var(--cms-text-primary);
    border-bottom: 1px solid var(--cms-border);
    vertical-align: top;
  }

  .event-title {
    font-size: 13px;
    font-weight: 700;
    color: var(--cms-text-primary);
    margin-bottom: 4px;
  }

  .event-subtitle {
    font-size: 12px;
    color: var(--cms-text-secondary);
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .participant-count-btn {
    min-width: 0;
    padding: 2px 4px;
    text-transform: none;
    font-size: 13px;
    font-weight: 700;
    text-decoration: underline;
    text-underline-offset: 3px;
  }

  .row-actions {
    display: flex;
    gap: 6px;
    align-items: center;
  }

  .table-empty {
    text-align: center;
    color: var(--cms-text-secondary);
    font-weight: 600;
    padding: 18px;
  }

  .pagination-wrap {
    display: flex;
    justify-content: flex-end;
    padding: 10px 0 0;
  }

  @media (max-width: 900px) {
    .filter-grid .search-field {
      grid-column: span 1;
    }
  }
`

export const StyledEventDialog = styled.div`
  .MuiDialog-paper {
    width: min(1120px, calc(100vw - 28px));
    max-width: none;
    border-radius: 20px;
    border: 1px solid var(--cms-border);
    background: var(--cms-dialog-bg);
    box-shadow: 0 28px 54px rgba(15, 23, 42, 0.2);
  }

  .MuiDialogTitle-root {
    padding: 20px 24px 8px;
  }

  .dialog-title-group {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .dialog-title {
    margin: 0;
    font-size: 22px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .dialog-subtitle {
    margin: 0;
    font-size: 13px;
    color: var(--cms-text-secondary);
    font-weight: 500;
  }

  .MuiDialogContent-root {
    padding: 14px 24px 10px;
  }

  .dialog-section-title {
    margin: 0 0 2px;
    font-size: 16px;
    font-weight: 800;
    color: var(--cms-text-primary);
  }

  .image-preview-panel {
    margin-top: 10px;
    padding: 10px;
    border: 1px solid var(--cms-border);
    border-radius: 10px;
    background: var(--cms-surface-muted);
  }

  .image-preview-label {
    margin: 0 0 8px;
    font-size: 12px;
    color: var(--cms-text-secondary);
    font-weight: 600;
  }

  .image-preview-wrap {
    display: flex;
    justify-content: center;
  }

  .image-preview {
    width: 100%;
    max-width: 360px;
    max-height: 240px;
    object-fit: contain;
    border-radius: 6px;
    border: 1px solid var(--cms-border);
    background: var(--cms-surface-secondary);
  }

  .MuiDialogActions-root {
    padding: 10px 24px 20px;
    gap: 10px;
  }

  .dialog-cancel-btn,
  .dialog-submit-btn {
    text-transform: none;
    border-radius: 10px;
    min-width: 108px;
    min-height: 40px;
    font-weight: 700;
  }

  .dialog-submit-btn {
    box-shadow: 0 12px 24px rgba(37, 99, 235, 0.24);
  }
`
